import React from 'react';
import { Section } from '../ui/Section';
export function Expectations() {
  return <Section background="dark" data-id="element-1">
      <div className="text-center mb-12" data-id="element-2">
        <h2 className="text-3xl font-bold text-[#f5f0e8] mb-4 font-serif" data-id="element-3">
          Lo que puedes esperar
        </h2>
        <p className="text-gray-500 text-sm uppercase tracking-widest" data-id="element-4">
          (Sin promesas mágicas)
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-5">
        {[{
        title: 'Menos escaladas',
        desc: 'De dolor antes de dormir'
      }, {
        title: 'Menos despertares',
        desc: 'Interrupciones por las manos'
      }, {
        title: 'Más control',
        desc: 'Porque ya sabes qué hacer'
      }, {
        title: 'Menos miedo',
        desc: 'A la hora de acostarte'
      }].map((item, idx) => <div key={idx} className="bg-[#1a1f2e] p-6 rounded-lg border-l-2 border-[#d4af37] hover:bg-[#202636] transition-colors" data-id="element-6">
            <h3 className="text-lg font-bold text-[#f5f0e8] mb-2" data-id="element-7">
              {item.title}
            </h3>
            <p className="text-gray-400 text-sm" data-id="element-8">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}